import { Component, DestroyRef, Inject, inject } from '@angular/core';
import { FormControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';

import * as fromApp from '@store';

export interface DialogData {
  line1: string;
  currentId?: number;
  currentName?: string;
  isDefault?: boolean;
}

@Component({
  selector: 'fc-dialog-change-dashboard-name',
  templateUrl: './dialog-change-dashboard-name.component.html',
  styleUrl: './dialog-change-dashboard-name.component.scss',
  standalone: false
})
export class DialogChangeDashboardNameComponent {
  destroyRef = inject(DestroyRef);
  changeForm: UntypedFormGroup;
  line1: string;
  currentId: number;
  createNewDashboard: boolean = true;
  isDefault: boolean = false;

  constructor(
    readonly store: Store<fromApp.AppState>,
    public dialogRef: MatDialogRef<DialogChangeDashboardNameComponent>,
    public dialog: MatDialog,
    readonly formBuilder: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {
    this.changeForm = this.formBuilder.group({
      newName: new FormControl(data.currentName, [
        Validators.required,
        Validators.maxLength(50)
      ]),
      createNewDashboard: new FormControl(false),
      isDefault: new FormControl(data.isDefault || false),
    });
    this.line1 = data.line1;
    this.currentId = data.currentId;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onSubmit() {
    this.dialogRef.close({
      name: this.changeForm.value.newName,
      id: this.changeForm.value.createNewDashboard ? null : this.currentId,
      isDefault: this.changeForm.value.isDefault,
    });
  }
}
